// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"a08a10df","460":"bf3f3faa","466":"c83c6601","514":"5650f315","674":"1187ea16","917":"a80d8147"}[chunkId] + ".chunk.js";
};